import React from 'react';
import styles from '../Operations.module.css';

interface MAPDComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MOBILEDOWNLOADS - Mobile App Downloads Customers (RO12)
 * KPI information component
 */
const MAPD: MAPDComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Mobile App Download Customers measures the total number of customers associated with your store that have downloaded the Ace Hardware mobile app in the past 12 months.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        The Ace mobile app continues to deliver exceptional commerce performance across all key KPIs. 
        <br/><br/>
        Now is the ideal time to accelerate mobile app downloads in your store—driving additional sales while also helping reduce mailing costs.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        500 mobile app engaged customers in the past 12 months
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Execute the Mobile App Playbook by completing the following actions:
        <ol>
          <li style={{ marginBottom: '1em' }}>
            <strong style={{ display: 'block' }}>Cashier Training:</strong>
            <div>Enroll all associates in the six short Ace Rewards training courses to ensure they fully understand the program’s benefits and key components.</div>
          </li>
          <li style={{ marginBottom: '1em' }}>
            <strong style={{ display: 'block' }}>Hang Signage:</strong>
            <div>Display Ace Rewards signage with QR codes throughout the store to promote enrollment through the Ace mobile app.</div>
          </li>
          <li style={{ marginBottom: '1em' }}>
            <strong style={{ display: 'block' }}>Distribute Take-With Collateral:</strong>
            <div>Provide Ace Rewards take-with materials at the registers. Instruct cashiers to staple app bag-stuffers to receipts for customers who do not yet have the mobile app, enabling them to download it at their convenience. Ensure app takeaway cards are stocked in the holder and displayed at each register.</div>
          </li>
          <li style={{ marginBottom: '1em' }}>
            <strong style={{ display: 'block' }}>Monitor with Reporting:</strong>
            <div>Track performance using the Mobile App Download Report available on ADW.</div>
            <div>Navigate to:</div>
            <div>AceNet → Analytics Dashboard → Store → Mobile App Download Report</div>
          </li>
        </ol>
      </div>
    </div>
  );
};

MAPD.title = 'Mobile App Downloads Customers - Ace Rewards';
MAPD.actionTitle = 'Mobile App Report';
MAPD.actionHyperlink = 'dynamicURL:WFC2:current';
export default MAPD;

